import { request } from 'helpers'

export function help(id, type) {
  return request.get(`/help/${id}?type=${type}`)
}
